<section id="main" class="bg-light">
     <div id="editUserContainer" class="container">
          <div class="overlay" *ngIf="isLoading">
               <h1 class="heading" [innerHtml]="'Loading' | translator:'base'"></h1>
               <img [alt]="'Loading' | translator:'base'" />
          </div>
          <div class="overlay" *ngIf="isSaving">
               <h1 class="heading">{{ 'SavingLoaderText' | translator:'base'}}</h1>
               <img alt="Loading" />
          </div>
          <div class="overlay" *ngIf="isSending">
               <h1 class="heading">{{ 'Sending' | translator:'customer'}}</h1>
               <img [alt]="'Sending' | translator:'base'" />
          </div>
          <h1>
               <span [innerHtml]="'EditUserTitle' | translator:'customer'">Permissions - </span> {{ customerId }} 
          </h1>
          <div class="row">
               <div class="col-lg-8">
                    <hr />
                    <h2 class="h5" [innerHtml]="'UserInfo' | translator:'customer'">User Info</h2>
                    <div class="row gx-2" [formGroup]="editUserGroup">
                         <div class="col-12 mb-3">
                              <label class="form-label" 
                                   for="username" 
                                   [innerHtml]="'Username' | translator:'base'"
                              >
                                   User Name
                              </label>
                              <input type="text" 
                                   class="form-control" 
                                   formControlName="userName" 
                                   id="username" 
                                   name="username"
                              />
                         </div>
                         <div class="col-12 col-md-6 mb-3 pe-md-2">
                              <div class="form-group">
                                   <label class="form-label" for="firstName" [innerHTML]="'FirstName' | translator:'base'">First Name</label>
                                   <span class="text-danger text-center ms-1" [title]="'Required' | translator:'base'">*</span>
                                   <input type="text" 
                                        class="form-control"
                                        formControlName="firstName" 
                                        id="firstName" 
                                        name="firstName"
                                        maxlength="50" 
                                        [title]="'FirstName' | translator:'base'"
                                   />
                                   <div *ngIf="firstName!.invalid && firstName!.dirty"
                                        class="help-block text-danger"
                                   >
                                        <div *ngIf="firstName!.errors?.['required']"
                                             [innerHTML]="'UserFirstName_required' | translator:'base'"
                                        >
                                             First Name is required.
                                        </div>
                                        <div *ngIf="firstName!.errors?.['maxLength']"
                                             [innerHTML]="'UserFirstName_max' | translator:'base'"
                                        >
                                             First Name must be 50 characters or less.
                                        </div>
                                        <div *ngIf="firstName!.errors?.['pattern']"
                                             [innerHTML]="'FirstName_invalid' | translator:'base'"
                                        >
                                             First Name contains invalid value(s). Please use only letters and numbers and these special characters (&, %, $, -).
                                        </div>
                                   </div>
                              </div>
                         </div>
                         <div class="col-12 col-md-6 mb-3 ps-md-2">
                              <div class="form-group">
                                   <label 
                                        class="form-label" 
                                        for="lastName" 
                                        [innerHTML]="'LastName' | translator:'base'"
                                   >
                                        Last Name
                                   </label>
                                   <span class="text-danger text-center ms-1" [title]="'Required' | translator:'base'">*</span>
                                   <input type="text" 
                                        class="form-control"
                                        formControlName="lastName" 
                                        id="lastName" 
                                        name="lastName"
                                        maxlength="50" 
                                        [title]="'LastName' | translator:'base'"
                                   />
                                   <div *ngIf="lastName!.invalid && lastName!.dirty"
                                        class="help-block text-danger"
                                   >
                                        <div *ngIf="lastName!.errors?.['required']"
                                             [innerHTML]="'UserLastName_required' | translator:'base'"
                                        >
                                              Last Name is required.
                                        </div>
                                        <div *ngIf="lastName!.errors?.['maxLength']"
                                             [innerHTML]="'UserLastName_max' | translator:'base'"
                                        >
                                             Last Name must be 50 characters or less.
                                        </div>
                                        <div *ngIf="lastName!.errors?.['pattern']"
                                             [innerHTML]="'LastName_invalid' | translator:'base'"
                                        >
                                             Last name contains invalid value(s). Please use only letters, apostrophes and spaces.
                                        </div>
                                   </div>
                              </div>
                         </div>
                         <div class="col-12 mb-3">
                              <div class="form-group">
                                   <label class="form-label" 
                                        for="email"
                                        [innerHTML]="'Email' | translator:'base'"
                                   >
                                        Email
                                   </label>
                                   <input type="text" 
                                        class="form-control" 
                                        formControlName="email" 
                                        id="email" 
                                        name="email"
                                        [title]="'Email' | translator:'base'" 
                                   />
                              </div>
                         </div>
                    </div>
                    <div class="d-flex mb-3 mb-lg-0">
                         <a routerLink="/userAccountAdmin" 
                              class="btn btn-primary btn-strong me-2" 
                              [title]="'Back' | translator:'base'"
                              [innerHtml]="'Back' | translator:'base'" 
                              name="Back" 
                              id="Back"
                         >
                         Back
                         </a>
                    </div>
               </div>
               <div class="col-lg-4 order-lg-2 sidebar">
                    <div class="card shadow-sm rounded-0 border-0">
                         <div class="card-body">
                              <h2 class="h5" [innerHtml]="'UserRolesHeader' | translator:'customer'" >User Roles</h2>
                              <table class="table table-striped permission-types-table">
                                   <thead>
                                        <tr>
                                             <th [innerHtml]="'PermissionTypes' | translator:'customer'">Permission Types</th>
                                        </tr>
                                   </thead>
                                   <tbody>
                                        <tr *ngFor="let role of roles; let index = index">
                                             <td>
                                                  <div class="form-check">
                                                       <label [for]="role.roleName" class="form-check-label">
                                                            <input type="checkbox" 
                                                                 [name]="role.roleName"
                                                                 [id]="role.roleName" 
                                                                 [(ngModel)]="role.isSelected"
                                                                 [value]="role.isSelected"
                                                                 [disabled]="true"
                                                                 class="form-check-input" />
                                                            {{ role.roleName | translator:'customer' }}
                                                       </label>
                                                  </div>
                                             </td>
                                        </tr>
                                   </tbody>
                              </table>
                            
                              <div class="help-block text-danger"
                                   *ngIf="isLoading === false && rolesAreValid === false">{{ 'RolesRequired' | translator:'customer' }}</div>
                         </div>
                    </div>
               </div>
          </div>
     </div>
</section>